import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

let defaultContext;

export default function(component) {
    if (!defaultContext) {
        defaultContext = new DragDropContext(HTML5Backend);
    }

    return defaultContext(component);
}